import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

export const GlobalDndContext = ({ children }: { children: React.ReactNode }) => (
  <DndProvider backend={HTML5Backend} key={1}>{children}</DndProvider>
);

export default GlobalDndContext;
